<template>
  <v-card v-if="hasDataToShow" :class="[margin]">
    <v-card-text>
      <v-layout>
        <v-flex v-if="ageGroup !== ''">
          <div>
            <v-label>{{ $t('candidate-student-profile-age', language) }}</v-label>
          </div>
          <div>{{ ageGroup }}</div>
        </v-flex>
        <v-flex v-if="studyYearsGroup !== ''">
          <div>
            <v-label>{{ $t('candidate-student-profile-study-years', language) }}</v-label>
          </div>
          <div>{{ studyYearsGroup }}</div>
        </v-flex>
        <v-flex v-if="isNotFromFrance && frenchLanguageTestPassed !== ''">
          <div>
            <v-label>{{ $t('candidate-student-profile-french-test', language) }}</v-label>
          </div>
          <div>{{ frenchLanguageTestPassed }}</div>
        </v-flex>
      </v-layout>
    </v-card-text>
  </v-card>
</template>

<script>
import { Consts } from '@/helpers/consts'
import dayjs from 'dayjs'

export default {
  data() {
    return {
      language: 'fr' // Student profile is always in french for now
    }
  },
  props: {
    profile: {
      type: Object,
      required: true
    },
    margin: {
      type: String,
      required: true
    }
  },
  computed: {
    hasDataToShow: function() {
      return this.ageGroup !== '' || this.studyYearsGroup !== '' || this.frenchLanguageTestPassed !== ''
    },
    ageGroup: function() {
      if (this.profile.birthdate === undefined || this.profile.birthdate === null) {
        return ''
      }

      const age = dayjs().diff(dayjs(this.profile.birthdate), 'year')
      if (age < 18) {
        return this.$t('candidate-profile-educational-age-under-18', this.language)
      } else if (age >= 18 && age < 25) {
        return this.$t('candidate-profile-educational-age-group', this.language, { from: 18, to: 24 })
      } else if (age >= 25 && age < 35) {
        return this.$t('candidate-profile-educational-age-group', this.language, { from: 25, to: 34 })
      } else if (age >= 35 && age < 45) {
        return this.$t('candidate-profile-educational-age-group', this.language, { from: 35, to: 44 })
      } else if (age >= 45 && age < 55) {
        return this.$t('candidate-profile-educational-age-group', this.language, { from: 45, to: 54 })
      } else {
        return this.$t('candidate-profile-educational-age-over-55', this.language)
      }
    },
    studyYearsGroup: function() {
      switch (this.profile.educationLevel) {
        case Consts.EDUCATION_LEVEL_LESS_THAN_12:
          return this.$t('candidate-profile-educational-scholarity-level-under-12', this.language)
        case Consts.EDUCATION_LEVEL_MORE_THAN_12:
          return this.$t('candidate-profile-educational-scholarity-level-specific', this.language, { years: 12 })
        case Consts.EDUCATION_LEVEL_MORE_THAN_13:
          return this.$t('candidate-profile-educational-scholarity-level-specific', this.language, { years: 13 })
        case Consts.EDUCATION_LEVEL_MORE_THAN_14:
          return this.$t('candidate-profile-educational-scholarity-level-specific', this.language, { years: 14 })
        case Consts.EDUCATION_LEVEL_MORE_THAN_15:
          return this.$t('candidate-profile-educational-scholarity-level-specific', this.language, { years: 15 })
        case Consts.EDUCATION_LEVEL_MORE_THAN_16:
          return this.$t('candidate-profile-educational-scholarity-level-specific', this.language, { years: 16 })
        case Consts.EDUCATION_LEVEL_MORE_THAN_17:
          return this.$t('candidate-profile-educational-scholarity-level-17-and-more', this.language)
        default:
          return ''
      }
    },
    frenchLanguageTestPassed: function() {
      const result = this.profile.frenchLanguageTestPassed
      if (result === Consts.FRENCH_LANGUAGE_TEST_PASSED_YES) {
        return this.$t('yes-option', this.language)
      } else if (result === Consts.FRENCH_LANGUAGE_TEST_PASSED_NO) {
        return this.$t('no-option', this.language)
      } else if (result === Consts.FRENCH_LANGUAGE_TEST_PASSED_NO_BUT_FRENCH_IS_FIRST_LANGUAGE) {
        return this.$t('candidate-profile-french-language-test-passed-no-but-french-is-first-language-label', this.language)
      } else {
        return ''
      }
    },
    isNotFromFrance: function() {
      return this.profile.nationalities.filter(x => x.countryCode === Consts.FRANCE_COUNTRY_CODE).length === 0
    }
  }
}
</script>
